import styled, { css } from 'styled-components'
import { Link, NavLink } from 'react-router-dom';

export const SC_Navbar = styled.nav.attrs(props => ({
  className: "navbar navbar-dark navbar-expand-lg",
}))`
	margin-bottom: ${props => props.theme.spacers[6]};
`

export const SC_NavbarBrand = styled.div.attrs(props => ({
  className: "navbar-brand",
}))`
	padding: 0;
	> a {
		display: flex;
	}
`

export const SC_NavbarBrandDivider = styled.div.attrs(props => ({
 
}))`
	width: ${props => props.theme.inputBtnBorderWidth};
	margin: 0 10px;
	background: ${props => props.theme.navbarDarkTogglerBorderColor};
`

export const SC_NavbarToggler = styled.button.attrs(props => ({
  className: "navbar-toggler btn",
  'aria-controls': "navbar-menu-content",
}))`
	border-width: ${props => props.theme.inputBtnBorderWidth};
`

export const SC_NavbarTogglerIcon = styled.span.attrs(props => ({
  className: "navbar-toggler-icon",
}))`
	height: 1.2em;
	width: 1.2em;
`

export const SC_NavbarCollapse = styled.div.attrs(props => ({
  className: "navbar-collapse collapse animated fadeIn",
}))`
	@media ${props => props.theme.breakpointsMin.lg} {
		margin-right: 200px; // temporary to center nav bc hidden login button 
	}
`

export const SC_NavbarNav = styled.ul.attrs(props => ({
  className: "navbar-nav",
}))`
	margin-left: ${props => props.align == 'center' ? 'auto' : 0};
	margin-right: ${props => props.align == 'center' ? 'auto' : 0};
	align-items: center;

	${props => props.align == 'center' ?
	`.nav-link {
		text-align: center;
	}`
	: null }

	@media ${props => props.theme.breakpointsMin.lg} {
		&:last-child .nav-item:first-child {
			order: 2;
			margin-left: ${props => props.theme.spacer};
		} 
	}

	@media ${props => props.theme.breakpointsMax.lg} {
		font-size: 1.2rem;

		&:last-child {
			flex-direction: row;
			flex-wrap: wrap;

			.nav-item {
				width: 50%;
				text-align: center;
			}
			
			.nav-item:first-child {
				width: 100%;
				
				.btn {
					display: inline-block;
					margin: ${props => props.theme.spacer} auto;
				}
			}
		} 
	}
`

export const SC_NavItem = styled.li.attrs(props => ({
	className: "nav-item",
}))`
	
`

export const SC_NavLink = styled(NavLink).attrs(props => ({
  className: "nav-link",
}))`

`

export const SC_Link = styled(Link).attrs(props => ({
  className: "nav-link",
}))`
	${props => props.active == 'true' ? 
	`color: ${props.theme.navbarDarkActiveColor}!important;` 
	: null }
	${props => props.loading ? 
	`opacity: 0;`
	: null }	
`

export const SC_Button = styled(NavLink).attrs(props => ({
  className: "btn btn-outline-light",
}))`
	${props => props.loading ? 
	`opacity: 0;`
	: null }

	
`

export const SC_SROnly = styled.span.attrs(props => ({
  className: "sr-only",
}))`

`